import { useTranslation } from 'react-i18next';

import Heading from '@atoms/Heading';

const AboutPage = () => {
  const { t } = useTranslation();

  return (
    <section>
      <Heading>
        { t('about:title') }
      </Heading>
    </section>
  );
};

export default AboutPage;
